import { Injectable } from '@angular/core';
import { Presenter } from 'src/app/core/presenter';
import { ExternalUsersView } from '../external-users.view';
import { PersonService } from 'src/app/services/person.service';
import { EstablishmentService } from 'src/app/services/establishment.service';
import { PersonInput } from 'src/app/model.ts/person.model';
import { UsersRolesPermissionsService } from 'src/app/services/users-roles-permissions.service';

@Injectable()
export class ExternalUsersPresenter implements Presenter {
    view: ExternalUsersView;

    constructor(
        public personService: PersonService,
        private establishmentService: EstablishmentService,
        public usersRolesPermissionsService: UsersRolesPermissionsService
    ) { }

    listWarehousesByValue() {
        const supplyWarehouses = [];
        this.view.blockUi();
        this.establishmentService.listWarehousesByValueAssignment('').subscribe(
            (data) => {
                data.data.warehouseByValue.forEach((element) => {
                    if (element.supply) {
                        supplyWarehouses.push(element);
                    }
                });
                this.view.warehouses = supplyWarehouses;
                this.view.allowUi();
            },
            (error) => {
                this.view.showError('Error', error);
                console.log('listWarehousesByValue', error);
            }
        );
    }

    saveExternalPerson(personInput: PersonInput) {
        this.view.blockUi();
        personInput.warehouse = this.personService.omitType(personInput.warehouse);
        this.personService
            .saveExternalPerson(this.personService.omitType(personInput))
            .subscribe(
                (data) => {
                    this.view.listActiveUsers();
                    this.view.showSuccess('Correcto', 'Usuario Externo Guardado');
                    this.view.displayDialog = false;
                    this.view.allowUi();
                },
                (error) => {
                    this.view.showError('Error', error);
                }
            );
    }

    listUsers(active: boolean) {
        this.view.blockUi();
        this.usersRolesPermissionsService
            .listExternalUsersByStatus(
                this.view.page,
                this.view.size,
                this.view.value,
                active
            )
            .subscribe(
                ({ data }) => {
                    if (data) {
                        console.log('data.usersExternal', data.usersExternal);
                        this.view.totalElements = data.usersExternal.totalElements;
                        this.view.totalPages = data.usersExternal.totalPages;
                        this.view.users = data.usersExternal.data;
                        this.view.size = data.usersExternal.size;
                    } else {
                        this.view.showWarn(
                            'Atención',
                            'No existen usuarios en la base de datos'
                        );
                    }
                    this.view.allowUi();
                },
                (error) => {
                    this.view.showError('Error', error);
                }
            );
    }

    userById(userId: string) {
        this.view.blockUi();
        this.usersRolesPermissionsService.userById(userId).subscribe(
            ({ data }) => {
                data.userById.warehouse = this.personService.omitType(data.userById.warehouse);
                this.view.selectedUser = data.userById;
                this.view.loadFormForEdit(this.view.selectedUser);
                this.view.displayDialog = true;
                this.view.allowUi();
            },
            (error) => {
                this.view.showError('Error', error);
            }
        );
    }
}
